import { Component, OnInit } from '@angular/core';
import {
  OrderService,
  ProductService,
  AuthenticationService,
  VentaService,
  ScriptService
} from '@app/core';
import { Order } from '@core/model/order.model';
import { ActivatedRoute } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';

import { Product } from '@app/core/model/product.model';
import { CurrencyPipe } from '@angular/common';
import { Subscription } from 'rxjs';
import Swal from 'sweetalert2';
import { PagoService } from '@app/core/service/pago.service';
declare let pdfMake: any;

@Component({
  selector: 'app-order-details',
  templateUrl: './order-details.component.html',
  styleUrls: ['./order-details.component.css']
})
export class OrderDetailsComponent implements OnInit {
  orders: Order[];
  id: string;
  isLoading = false;
  orden: any;
  form: FormGroup;
  totalSum = 0;
  totalPagado = 0;
  totalDeuda = 0;
  fecha_orden: string;
  fecha_entrega: string;
  currentUserSubscription: Subscription;

  currentUser: any;
  userid: string;

  value: boolean;
  myFormValueChanges$: any;
  products: Product[];

  nombre_cliente = '';
  nit = '';
  direccion = '';
  fecha_pedido = '';
  fecha = '';
  list: any;
  venta_id = '';
  orden_id = '';

  monto: string;

  pago: string;
  selected: any;

  formPago: FormGroup;
  formPago2: FormGroup;
  pagos: any;
  constructor(
    private ventaService: VentaService,
    private pagoService: PagoService,
    private fb: FormBuilder,
    private productService: ProductService,
    private currencyPipe: CurrencyPipe,
    private route: ActivatedRoute,
    private authService: AuthenticationService,
    private scriptService: ScriptService,
    private datePipe: DatePipe
  ) {
    this.scriptService.load('pdfMake', 'vfsFonts');
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.id = params.id;

      this.listarOrden();
      this.listarPagos(this.id);
    });

    this.formPago = this.fb.group({
      pagos: this.fb.array([])
    });
  }

  get formData() {
    return <FormArray>this.formPago.get('pagos');
  }

  get formData2() {
    return <FormArray>this.formPago2.get('pagos2');
  }

  nuevoPago() {
    const pagos = this.formPago.controls.pagos as FormArray;
    pagos.push(
      this.fb.group({
        pago_id: '',
        fecha: new Date().toISOString().substring(0, 10),
        monto: [0, [Validators.required]],
        proximo_pago:new Date().toISOString().substring(0, 10)
      })
    );
  }

  listarPagos(id: string) {
    this.formPago2 = this.fb.group({
      pagos2: this.fb.array([])
    });

    this.pagoService.listarPagos(id).subscribe(
      data => {
        this.pagos = data;
        console.log(this.pagos);
        this.totalPagado = this.calculateTotalPagado();

        if (this.pagos.length > 0) {
          const control = <FormArray>this.formPago2.controls['pagos2'];
          for (let i = 1; i < this.pagos.length + 1; i++) {
            console.log(this.pagos[i - 1].pago_id);
            control.push(
              this.fb.group({
                pago_id: this.pagos[i - 1].pago_id,
                fecha: '',
                monto: 0,
                proximo_pago:''
              })
            );
          }

          this.formPago2.patchValue({ pagos2: this.pagos });
        }
        // console.log(this.goleadores);
        // this.modeloEditar.arbitro_id = this.arbitros[0].arbitro_id;
      },
      error => {}
    );
  }

  guardarPago() {
    const pago = {
      venta_id: this.id,
      pagos: this.formPago.get('pagos').value
    };

    //  const obj = this.formGol.get('goleadores').value; // JSON.parse(this.form.value);
    console.log(pago);

    Swal.fire({
      title: 'Esta seguro de registrar el pago?',
      text: '',
      type: 'warning',
      showConfirmButton: true,
      showCancelButton: true
    }).then(willDelete => {
      if (willDelete.value) {
        this.pagoService.realizarPago(pago).subscribe(
          data => {
            // this.formGol.reset();
            alert('El pago se registro correctamente');
            // this.formPago.controls.pagos.em
            this.formPago = this.fb.group({
              pagos: this.fb.array([])
            });
            this.listarPagos(this.id);
          },
          error => {
            alert(error.error);
          }
        );
      } else {
        Swal.fire('No se pudo registrar');
      }

      console.log(willDelete);
    });
  }

  eliminarPago(index: any) {
    const control = <FormArray>this.formPago.controls.pagos;
    control.removeAt(index);
  }
  eliminarPagoDB(index: any) {
    Swal.fire({
      title: 'Esta seguro de Eliminar el ingreso?',
      text: 'Una vez eliminado, Ud no podra recuperar el pago eliminado!',
      type: 'warning',
      showConfirmButton: true,
      showCancelButton: true
    }).then(willDelete => {
      if (willDelete.value) {
        this.pagoService.delete(index.value.pago_id).subscribe(
          data => {
            // this.formGol.reset();
            alert('El pago se elimino correctamente');
            // this.formPago.controls.pagos.em

            this.listarPagos(this.id);
          },
          error => {
            alert(error.error);
          }
        );
      } else {
        Swal.fire('No se pudo eliminar');
      }

      console.log(willDelete);
    });
  }

  listarOrden() {
    this.isLoading = true;

    this.ventaService
      .ventaDetalle(this.id)
      .pipe(
        finalize(() => {
          // this.userForm.markAsPristine();
          this.isLoading = false;
        })
      )
      .subscribe(
        (data: any) => {
          console.log(data);
          // this.salas = data;

          this.orden = data;
          this.nombre_cliente =
            this.orden.cliente.nombres + ' ' + this.orden.cliente.apellidos;
          this.nit = this.orden.cliente.ci_nit;
          this.direccion = this.orden.cliente.direccion;
          this.fecha_entrega = this.orden.fecha_entrega;
          this.fecha_pedido = this.orden.fecha;
          this.list = this.orden.list;
          this.pago = this.orden.tipo_pago;
          this.monto = this.orden.cancelado;
          this.venta_id = this.id;
          this.orden_id = this.orden.orden_id;

          this.totalSum = this.calculateTotal();
        },
        (error: any) => {
          console.log({ title: error.error, type: 'error' });
        }
      );
  }

  public calculateTotal() {
    return this.list.reduce(
      (accum: any, curr: any) => accum + curr.cantidad * curr.precio,
      0
    );
  }

  public calculateTotalPagado() {
    return this.pagos.reduce((accum: any, curr: any) => accum + curr.monto, 0);
  }

  imprimirVenta() {
    // console.log(this.orden);
    let total = 0;

    for (const data2 of this.orden.list) {
      total += data2.cantidad * data2.precio;
    }

   
  }
}
